import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { z } from "zod";
import { useI18n } from "@/lib/i18n";

const searchSchema = z.object({
  session_id: z.string().optional(),
});

export const Route = createFileRoute("/checkout/return")({
  validateSearch: searchSchema,
  component: CheckoutReturn,
  head: () => ({
    meta: [
      { title: "Trial started — AdKavi" },
      { name: "robots", content: "noindex" },
    ],
  }),
});

function CheckoutReturn() {
  const { session_id } = Route.useSearch();
  const { t } = useI18n();
  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full rounded-2xl border border-border/50 bg-card/50 backdrop-blur p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-primary/15 mx-auto mb-4 flex items-center justify-center">
          <CheckCircle2 className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-2xl font-bold">{t("checkout.return.title")}</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {t("checkout.return.desc")}
        </p>
        <Link
          to="/dashboard"
          className="mt-6 inline-flex items-center justify-center rounded-full bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          {t("checkout.return.cta")}
        </Link>
        {session_id && (
          <p className="mt-4 text-xs text-muted-foreground/70 break-all">
            {t("checkout.return.reference")} {session_id}
          </p>
        )}
      </div>
    </main>
  );
}
